__turbopack_context__.v({
  "questionnaireSection": "QuestionnaireSection-module__HyAncG__questionnaireSection",
});
